import { combineReducers } from 'redux'
import paymentIqTransactionHistoryReducer from './paymentIq/transactionHistoryReducer'

const ExternalCashierReducer = combineReducers({
  paymentIqTransactionHistory: paymentIqTransactionHistoryReducer,
})

export default ExternalCashierReducer